import React from 'react';
import { FaStar } from 'react-icons/fa';
import './CourseDetailPage.css';

const CourseInfo = ({ 
  instructor, 
  rating, 
  reviewCount, 
  studentCount, 
  originalPrice, 
  price, 
  isLimited,
  features 
}) => {
  return (
    <div className="course-info-card">
      <div className="price-section">
        <div className="price-label">优惠价</div>
        <div className="price-value">
          <span className="current-price">{price.toFixed(2)}元</span>
          <span className="original-price">{originalPrice.toFixed(2)}元</span>
        </div>
        {isLimited && <div className="limited-offer">有效期：长期有效</div>}
      </div>
      
      <button className="enroll-button">购买班级</button>
      
      <div className="instructor-section">
        <img src="https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg" alt={instructor} className="instructor-avatar" />
        <div className="instructor-info">
          <div className="instructor-name">{instructor}</div>
          <div className="course-stats">
            <div className="rating">
              <span>{rating.toFixed(1)}</span>
              {[1, 2, 3, 4, 5].map(star => (
                <FaStar key={star} className={star <= rating ? "star-filled" : "star-empty"} />
              ))}
            </div>
            <div className="student-count">{studentCount}人学习</div>
          </div>
        </div>
      </div>
      
      <div className="course-features">
        <h3>课程服务包含：</h3>
        <ul>
          {features && features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CourseInfo; 